<template>
  <div
    :class="[
      'nav-menu-wrap',
      menuIsShow ? 'show-list' : 'close-list',
      showStyle === 2 ? 'show-style' : '',
      isInTelegramWebApp ? 'isInTelegramWebApp' : '',
    ]"
    @click.self="menuClick2"
  >
    <div
      class="logo"
      v-if="getIsMobile"
      :class="{
        isInTelegramWebApp: isInTelegramWebApp,
      }"
    >
      <HHeader :isMenu="true" />
    </div>
    <el-menu
      :class="[
        'nav-menu-list',
        getIsMobile ? 'IsMobile' : '',
        isInTelegramWebApp ? 'isInTelegramWebApp' : '',
        h5ShowType === 'H5_SHOW_TYPE_HALF_SCREEN' ? 'halfScreen' : '',
      ]"
      ref="menu"
      @open="handleOpen"
      @select="handleSelect"
      @close="handleClose"
      :collapse-transition="false"
      unique-opened
      :collapse="!menuIsShow"
    >
      <div class="search-container" v-if="getIsMobile" v-exposure="{ eid: `101_0_0_128` }" :data-id="`101_0_0_128`">
        <el-input
          :readonly="true"
          :placeholder="$t('Datalang.Betrecord_TITLE_gamename')"
          prefix-icon="el-icon-search"
          @focus="clickSearch"
        ></el-input>
      </div>
      <div class="grid-box grid-wrap">
        <div
          :class="['grid-item', 'nav-row-warp', `type${item.menuType}`, `hasIconType${item.iconType}`]"
          v-for="item in pNavs"
          :key="item.sid"
        >
          <el-submenu
            :class="['nav-row', `nav-row${item.iconType}`]"
            v-if="item.childMenu && item.childMenu.length"
            :index="String(item.sid)"
          >
            <div slot="title">
              <div
                :class="['nav-icon-wrap', `iconType${item.iconType}`, openMenu[item.sid] ? 'active' : '']"
                v-exposure="{ eid: item.eid, jump_vlaue: item?.jump || {} }"
                :data-id="item.eid"
              >
                <img class="nav-icon unselected" :src="getIconMap(item.language, 1)" alt="" />
                <img class="nav-icon selected" :src="getIconMap(item.language, 2)" alt="" />
                <img class="nav-icon iconSmall" :src="getIconMap(item.language, 3)" alt="" />
              </div>
              <span
                :class="['name', `name${item.iconType}`, openMenu[item.sid] ? 'titelAcl' : '']"
                slot="title"
                v-show="menuIsShow"
              >
                {{ langName(item.language) }}
              </span>
            </div>
            <div class="grid-box">
              <el-menu-item
                :class="[
                  'grid-item',
                  'nav-row',
                  `nav-row${chil.iconType}`,
                  `type${chil.menuType}`,
                  `hasIconType${chil.iconType}`,
                ]"
                v-for="chil in item.childMenu"
                :key="chil.sid"
                :index="String(chil.sid)"
              >
                <div
                  :class="['nav-icon-wrap', `iconType${chil.iconType}`, selectMenu === chil.sid ? 'active' : '']"
                  v-exposure="{ eid: chil.eid, jump_vlaue: chil?.jump || {} }"
                  :data-id="chil.eid"
                >
                  <img class="nav-icon unselected" :src="getIconMap(chil.language, 1)" alt="" />
                  <img class="nav-icon selected" :src="getIconMap(chil.language, 2)" alt="" />
                  <img class="nav-icon iconSmall" :src="getIconMap(item.language, 3)" alt="" />
                </div>
                <span :class="['name', `name${chil.iconType}`, selectMenu === chil.sid ? 'titelAcl' : '']" slot="title">
                  {{ langName(chil.language) }}
                </span>
              </el-menu-item>
            </div>
          </el-submenu>
          <el-menu-item :class="['nav-row', `nav-row${item.iconType}`]" v-else :index="String(item.sid)">
            <div
              :class="['nav-icon-wrap', `iconType${item.iconType}`, selectMenu === item.sid ? 'active' : '']"
              v-exposure="{ eid: item.eid, jump_vlaue: item?.jump || {} }"
              :data-id="item.eid"
            >
              <img class="nav-icon unselected" :src="getIconMap(item.language, 1)" alt="" />
              <img class="nav-icon selected" :src="getIconMap(item.language, 2)" alt="" />
              <img class="nav-icon iconSmall" :src="getIconMap(item.language, 3)" alt="" />
            </div>
            <span :class="['name', `name${item.iconType}`, selectMenu === item.sid ? 'titelAcl' : '']" slot="title">
              {{ langName(item.language) }}
            </span>
            <div class="redPoint" v-if="havePoint(item)"></div>
          </el-menu-item>
        </div>
      </div>
      <div :style="`width: 100%; height: ${$px2rem(isTgApp ? 85 : 65)}`" v-if="getIsMobile"></div>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import { resMenuList } from "@/lobby_common/api/basic_gen.js";
import { resMenuListC as resMenuList } from "@/lobby_common/api/cacheApi";
import Bus from "@/lobby_common/utils/bus.js";
import { goJoinEvent } from "@/lobby_common/utils/utils.js";
import celanbtn from "@/assets/home/celan_btn.png";
import HHeader from "../header/h-header.vue";
import { lock, unLock } from "@/lobby_common/utils/index.js";
import { cacheKeys } from "@/lobby_common/utils/commonEnum.js";
export default {
  name: "nav-menu",
  props: ["showDown"],
  mixins: [],
  components: {
    HHeader,
  },
  data() {
    return {
      celanbtn,
      pNavs: [],
      openMenu: {},
      selectMenu: "",
      curItem: {},
      timer: null,
      initDefaultOpen: true, // 初始化展开一次
      h5ShowType: "", // H5_SHOW_TYPE_FULL_SCREEN, H5_SHOW_TYPE_HALF_SCREEN
      cacheKeys,
    };
  },
  async created() {
    // 获取菜单
    await this.getMenu();
  },
  mounted() {
    const that = this;
    // Bus.$off("changeFooterNav2");
    Bus.$on("changeFooterNav2", function (index) {
      that.handleSelect(index);
    });
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    unLock();
  },
  computed: {
    logo() {
      return this.$utils.returnImgUrl(this.$store.getters.getPacketConfig?.site?.indexLogo);
    },
    lang() {
      return this.$store.getters.getLang;
    },
    packetConfig() {
      return this.$store.getters.getPacketConfig?.packetInfo?.baseInfo || {};
    },
    showStyle() {
      return this.packetConfig.style || 1;
    },
    isAndroid() {
      const u = navigator.userAgent;
      const android = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 安卓机！
      return android;
    },
    ...mapGetters(["menuIsShow", "getIsMobile", "sidebarWidth"]),
  },
  watch: {
    menuIsShow: {
      handler: function (val) {
        if (!val) {
          this.handleClose();
          unLock();
        } else {
          if (this.getIsMobile) {
            lock();
          }
          this.defaultOpen();
        }
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    ...mapActions(["setMenuBar"]),
    menuClick() {
      this.setMenuBar(!this.menuIsShow);
    },
    menuClick2() {
      this.setMenuBar(false);
    },
    clickSearch() {
      // this.setMenuBar(false);
      this.$eventPost("click", {
        eid: `101_0_0_128`,
        time: Date.now(),
      });
      this.$Bus.$emit("changeSearchDrawer");
    },
    async handleSelect(key, keyPath) {
      // 点击当前菜单
      // if (Number(key) === this.selectMenu) return;

      this.$set(this, "selectMenu", String(key));

      let flatList = [...this.pNavs];
      this.pNavs.map((item) => {
        if (item.childMenu && item.childMenu.length) {
          flatList = [...flatList, ...item.childMenu];
        }
      });
      const list =
        flatList.filter((v) => {
          return String(v.sid) === String(key);
        }) || [];
      this.curItem = list[0] || {};
      // console.log(key, keyPath, this.curItem);
      // 点击底部菜单展开收起一级菜单
      if (!keyPath && this.curItem?.childMenu?.length) {
        const fun = this.openMenu[key] ? this.handleClose : this.handleOpen;
        if (this.openMenu[key]) {
          this.$refs.menu?.close(key);
        } else {
          this.$refs.menu?.open(key);
        }
        fun(key);
        return;
      }

      console.log("this.curItem", this.curItem);
      // 数据埋点
      let enName = "";
      enName = this.curItem.language.name;
      // this.curItem.language?.map((v) => {
      //   if (v.language === "en") enName = v.name;
      // });
      const eventName = this.curItem.level === 1 ? "click_menu_first" : "click_menu_second";
      this.$eventPost(eventName, {
        menuId: this.curItem.sid,
        menuName: enName,
        enum: this.curItem?.jump?.functionType || "",
        jump_vlaue: this.curItem?.jump || {},
      });
      this.$eventPost("click", {
        eid: this.curItem.eid,
        time: Date.now(),
        menuId: this.curItem.sid,
        menuName: enName,
        enum: this.curItem?.jump?.functionType || "",
        jump_vlaue: this.curItem?.jump || {},
      });

      if (this.getIsMobile && keyPath) {
        this.setMenuBar(false);
      }

      if (this.curItem.jump.type === "Jump_TYPE_MULTIPLE_GAME") {
        // 多款游戏
        this.curItem["bindType"] = 1;
        localStorage.setItem("Cur_params", JSON.stringify(this.curItem));
        const { key, jumpName1, jumpName2 } = this.curItem?.jump?.multipleGame;
        if (jumpName1) {
          goJoinEvent(this.curItem.jump);
          return;
        } else if (key && this.cacheKeys.includes(key)) {
          // 缓存
          this.$router.push({ name: key + "1" }); // router和组件的name都在key的后面拼了1, +1才能匹配上
        } else {
          const flag = { flag: new Date().getTime() };
          this.$router.push({ name: "homeSearch", query: flag });
        }
      } else {
        // 其他
        goJoinEvent(this.curItem.jump);
      }
    },
    async getMenu() {
      this.pNavs = [];
      // 接口获取的pc菜单数据
      const { code, data } = await resMenuList({
        resType: this.getIsMobile ? "h5" : "pc",
      });
      if (code === 0) {
        const list = data.menuList || [];
        this.h5ShowType = data.h5ShowType;
        const pcMenu = list;
        // 将菜单数据存到缓存
        localStorage.setItem("Pc_Menu_Info", JSON.stringify(pcMenu));
        // this.$Bus.$emit("footerMenu");
        // this.pNavs = [...this.pNavs, ...pcMenu];
        const navs = [...this.pNavs, ...pcMenu];
        navs.map((item, index) => {
          item.eid = `101_26_${index}_0`;
          if (item.childMenu && item.childMenu.length) {
            item.childMenu.map((it, i) => {
              it.eid = `101_26_${index}_${i + 1}`;
            });
          }
        });
        this.pNavs = navs;
        this.defaultOpen();
      }
    },
    getIconMap(obj = {}, flag = 1) {
      const unSelectSrc = this.$utils.returnImgUrl(obj.iconUnselected);
      const selectSrc = this.$utils.returnImgUrl(obj.icon);
      const iconSmall = obj.iconSmall ? this.$utils.returnImgUrl(obj.iconSmall) : unSelectSrc;
      const map = {
        1: unSelectSrc,
        2: selectSrc,
        3: iconSmall,
      };
      return map[flag];
    },
    langName(obj = {}, field = "name") {
      return obj[field];
    },
    // 是否有小红点
    havePoint(obj) {
      const allPoint = this.$store.getters.getAllPoint;
      const jump = obj.jump || {};
      // 开关是否开启
      const isOpen = this.$store?.getters?.getPacketConfig?.packetInfo?.baseInfo?.userOnboarding === "STATUS_BOOL_TRUE";
      return isOpen && allPoint.includes(jump.functionType);
    },
    handleOpen(key, keyPath) {
      this.openMenu = {};
      this.$set(this.openMenu, key, key);
      console.log(key, keyPath);

      // let flatList = [...this.pNavs];
      // this.pNavs.map((item) => {
      //   if (item.childMenu && item.childMenu.length) {
      //     flatList = [...flatList, ...item.childMenu];
      //   }
      // });
      // const list =
      //   flatList.filter((v) => {
      //     return String(v.sid) === String(key);
      //   }) || [];
      // let curItem = list[0] || {};
      // this.$eventPost('click_menu_second', { menuId: curItem.sid, menuName: curItem.language.name, });
    },
    handleClose(key, keyPath) {
      this.openMenu = {};
      this.$set(this.openMenu, key, undefined);
      console.log(key, keyPath);
    },
    defaultOpen() {
      if (this.initDefaultOpen && !this.getIsMobile && this.menuIsShow) {
        const hasChildItem = this.pNavs.filter((i) => i.childMenu?.length)[0];
        if (hasChildItem?.sid) {
          const timer = setTimeout(() => {
            this.$refs.menu?.open(hasChildItem.sid + "");
            this.handleOpen(hasChildItem.sid);
            this.initDefaultOpen = false;
            clearTimeout(timer);
          }, 200);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.close-list {
  .grid-box {
    display: block;
    &.grid-wrap {
      padding: 10px;
    }
    .grid-item {
      border-radius: 0px;
      background: transparent !important;
      height: 40px !important;
      width: 100% !important;
      .nav-row {
        height: 100 !important;
        width: 100% !important;
        transform: translateX(0) !important;
      }
      .nav-icon-wrap {
        right: 0px;
        position: static !important;
        height: auto !important;
      }
    }
    .unselected {
      display: none;
    }
    .selected {
      display: none !important;
    }
    .iconSmall {
      display: block;
      width: 100%;
      height: 100%;
      position: static !important;
    }
  }
}
.nav-menu-list.IsMobile {
  .grid-box {
    .type1.hasIconType2,
    .type2.hasIconType2 {
      height: 17vw;
    }
    .type3,
    .type4,
    .type5,
    .type12 {
      height: 41vw;
    }
    .type6,
    .type7,
    .type9,
    .type10,
    .type11 {
      height: calc(82vw + 10px);
    }
  }
  &.halfScreen {
    width: 80%;
    .grid-box {
      .type1.hasIconType2,
      .type2.hasIconType2 {
        height: 13.6vw;
      }
      .type3,
      .type4,
      .type5,
      .type12 {
        height: 32.8vw;
      }
      .type6,
      .type7,
      .type9,
      .type10,
      .type11 {
        height: calc(65.6vw + 10px);
      }
    }
  }
}
.show-list.show-style {
  .grid-box {
    gap: 7px; /* 可选：设置项之间的间距 */
    .grid-item.nav-row-warp {
      &.type0,
      &.type1,
      &.type8 {
        background-color: var(--background-1901);
        box-shadow: var(--boxShadow-800);
        border-radius: 5px;
        .nav-row {
          width: 100%;
          transform: translateX(0px);
          .type1 {
            padding-left: 20px !important;
            padding-right: 20px;
          }
        }
      }
      &.type1.hasIconType2 {
        box-shadow: none;
      }
      &.type2 {
        background-color: var(--background-1901);
      }
    }
  }
  ::v-deep .el-submenu__icon-arrow {
    font-size: 16px;
    background: var(--background-1903);
    transform: rotateZ(0deg);
  }
  ::v-deep .el-submenu.is-opened > .el-submenu__title {
    background: var(--background-1900);
    .el-submenu__icon-arrow {
      transform: rotateZ(-180deg);
      &::before {
        color: var(--font-color-200);
      }
    }
  }
  ::v-deep .el-menu-item {
    border-radius: 5px;
    &.is-active {
      background: var(--background-1900);
    }
    &:hover {
      background: var(--background-1902);
    }
    .name {
      font-weight: bold;
    }
  }
  .type1 {
    ::v-deep .el-menu-item {
      border-radius: 5px;
    }
  }
  ::v-deep .el-submenu__title {
    border-radius: 5px;
    &:hover {
      background: var(--background-1902);
    }
  }
}
.grid-box {
  width: 100%;
  display: grid;
  // background: var(--background-1200);
  grid-template-columns: repeat(2, 1fr);
  // grid-template-columns: repeat(auto-fill, 120px);
  gap: 10px; /* 可选：设置项之间的间距 */
  grid-auto-flow: row dense; // 表示"先行后列"，并且尽可能紧密填满，尽量不出现空格
  &.grid-wrap {
    padding: 10px;
    box-sizing: border-box;
  }
  .name {
    position: relative;
    z-index: 99;
  }
  .grid-item {
    grid-column: span 2;
    border-radius: 5px;
    box-sizing: border-box;
    .nav-row {
      height: 100%;
    }
    .name2 {
      color: var(--font-color-200);
    }
    &.type0 {
      .nav-row {
        width: calc(100% + 20px);
        transform: translateX(-10px);
      }
    }
    &.type1 {
      grid-row: auto / span 1;
      grid-column: span 2;
      .nav-row {
        width: calc(100% + 20px);
        transform: translateX(-10px);
        &.nav-row2 {
          width: 100%;
          transform: translateX(0px);
        }
      }
    }
    &.type2 {
      grid-row: auto / span 1;
      grid-column: span 1;
      overflow: auto;
      .nav-row {
        width: calc(100% + 10px);
        transform: translateX(-10px);
        &.nav-row2 {
          width: 100%;
          transform: translateX(0px);
        }
      }
    }
    &.type3 {
      grid-row: auto / span 2;
      grid-column: span 1;
      height: 110px;
      background: var(--background-800);
      .nav-row {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .iconType1 {
          width: 36px;
          height: 36px;
          margin-top: 10px;
          margin-right: 0;
          flex-shrink: 0;
        }
        .name2 {
          margin-top: 46px;
        }
      }
      .name {
        color: var(--font-color-200);
      }
    }
    &.type4 {
      grid-row: auto / span 2;
      grid-column: span 1;
      height: 110px;
      background: var(--background-800);
      .nav-row {
        display: flex;
        justify-content: space-between;
        padding: 0 10px !important;
        .iconType1 {
          width: 36px;
          height: 36px;
          margin-top: 5px;
          margin-right: 0;
          align-self: flex-start;
          flex-shrink: 0;
        }
        .name {
          align-self: flex-end;
          text-align: end;
          width: 100%;
        }
      }
      .name {
        color: var(--font-color-200);
        display: block;
        word-break: break-word;
        white-space: normal;
        line-height: 24px;
        margin-bottom: 10px;
      }
    }
    &.type5 {
      grid-row: auto / span 2;
      grid-column: span 1;
      height: 110px;
      background: var(--background-800);
      .nav-row {
        display: flex;
        flex-direction: column-reverse;
        justify-content: space-between;
        padding: 0 10px !important;
        &.nav-row2 {
          flex-direction: column;
        }
        .iconType1 {
          width: 36px;
          height: 36px;
          margin-bottom: 5px;
          margin-right: 0;
          align-self: flex-end;
          flex-shrink: 0;
        }
        .name {
          align-self: flex-start;
          text-align: start;
          width: 100%;
        }
      }
      .name {
        color: var(--font-color-200);
        display: block;
        word-break: break-word;
        white-space: normal;
        line-height: 24px;
        margin-top: 10px;
      }
    }
    &.type6 {
      grid-row: auto / span 4;
      grid-column: span 1;
      height: 230px;
      background: var(--background-800);
      .nav-row {
        display: flex;
        justify-content: space-between;
        padding: 0 10px !important;
        .iconType1 {
          width: 36px;
          height: 36px;
          margin-top: 5px;
          margin-right: 0;
          align-self: flex-start;
          flex-shrink: 0;
        }
        .name {
          align-self: flex-end;
          text-align: end;
          width: 100%;
        }
      }
      .name {
        color: var(--font-color-200);
        display: block;
        word-break: break-word;
        white-space: normal;
        line-height: 24px;
        margin-top: 10px;
      }
    }
    &.type7 {
      grid-row: auto / span 4;
      grid-column: span 1;
      height: 230px;
      background: var(--background-800);
      .nav-row {
        display: flex;
        flex-direction: column-reverse;
        justify-content: space-between;
        padding: 0 10px !important;
        &.nav-row2 {
          flex-direction: column;
        }
        .iconType1 {
          width: 36px;
          height: 36px;
          margin-bottom: 5px;
          margin-right: 0;
          align-self: flex-end;
          flex-shrink: 0;
        }
        .name {
          align-self: flex-start;
          text-align: start;
          width: 100%;
        }
      }
      .name {
        color: var(--font-color-200);
        display: block;
        word-break: break-word;
        white-space: normal;
        line-height: 24px;
        margin-top: 10px;
      }
    }
    &.type8 {
      grid-row: auto / span 1;
      grid-column: span 2;
      .nav-row {
        width: calc(100% + 20px);
        transform: translateX(-10px);
        &.type1 {
          width: calc(100% + 30px);
          padding-left: 30px !important;
        }
      }
    }
    &.type9 {
      font-size: 18px;
      grid-row: auto / span 4;
      grid-column: span 2;
      height: 230px;
      background: var(--background-800);
      .nav-row {
        display: flex;
        justify-content: space-between;
        padding: 0 10px !important;
        .iconType1 {
          width: 36px;
          height: 36px;
          margin-top: 5px;
          margin-right: 0;
          align-self: flex-start;
          flex-shrink: 0;
        }
        .name {
          align-self: flex-end;
          text-align: end;
          width: 80%;
          display: block;
          word-break: break-word;
          white-space: normal;
          line-height: 30px;
          margin-top: 10px;
        }
      }
      .name {
        font-size: 20px;
        color: var(--font-color-200);
        display: block;
        word-break: break-word;
        white-space: normal;
        line-height: 30px;
        margin-top: 10px;
      }
    }
    &.type10 {
      grid-row: auto / span 4;
      grid-column: span 2;
      height: 230px;
      background: var(--background-800);
      .nav-row {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .iconType1 {
          width: 36px;
          height: 36px;
          margin-top: 10px;
          margin-right: 0;
          flex-shrink: 0;
        }
        .name2 {
          margin-top: 46px;
        }
      }
      .name {
        font-size: 20px;
        color: var(--font-color-200);
      }
    }
    &.type11 {
      grid-row: auto / span 4;
      grid-column: span 2;
      height: 230px;
      background: var(--background-800);
      .nav-row {
        display: flex;
        flex-direction: column-reverse;
        justify-content: space-between;
        padding: 0 10px !important;
        &.nav-row2 {
          flex-direction: column;
        }
        .iconType1 {
          width: 36px;
          height: 36px;
          margin-bottom: 5px;
          margin-right: 0;
          align-self: flex-end;
          flex-shrink: 0;
        }
        .name {
          align-self: flex-start;
          text-align: start;
        }
      }
      .name {
        font-size: 20px;
        color: var(--font-color-200);
        width: 80%;
        display: block;
        word-break: break-word;
        white-space: normal;
        line-height: 30px;
        margin-top: 10px;
      }
    }
    &.type12 {
      grid-row: auto / span 2;
      grid-column: span 2;
      height: 110px;
      background: var(--background-800);
      .nav-row {
        display: flex;
        align-items: center;
        .iconType1 {
          width: 36px;
          height: 36px;
          margin-right: 10px;
          flex-shrink: 0;
        }
      }
      .name {
        font-size: 20px;
        color: var(--font-color-200);
      }
    }
  }
}
.nav-menu-wrap.close-list .grid-box {
  .grid-item {
    .nav-row {
      .iconType1 {
        width: 16px;
        height: 16px;
      }
    }
  }
}
.el-menu-item:hover,
.el-menu-item:focus {
  background-color: unset;
}

.search-container {
  padding: 10px 10px 0;
}
.serve-time {
  padding: 14px 0 14px 20px;
  line-height: 24px;
  font-size: 14px;
  color: var(--font-color-200);
}
.nav-menu-list:not(.el-menu--collapse) {
  width: 100%;
  min-height: 400px;
}
.nav-icon-wrap {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  position: relative;
  &.iconType2 {
    // 做背景
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    margin-right: 0;
    .iconSmall {
      width: 16px;
      height: 16px;
      margin: 0 auto;
    }
  }
  .nav-icon {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.nav-menu-wrap {
  height: 100%;
  overflow-y: auto;
  position: relative;
  .titelAcl {
    color: var(--font-color-1701);
  }
  .gap {
    height: 2px;
    background-color: var(--background-100);
    @media (max-width: 768px) {
      height: 5px;
      background-color: var(--background-100);
    }
  }
  &.close-list {
    ::v-deep .el-submenu__icon-arrow {
      display: none;
    }
    .serve-time {
      display: none;
    }
    ::v-deep .el-menu-item .el-tooltip {
      padding: 0 !important;
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      .nav-icon-wrap {
        margin-right: 0;
      }
    }
    ::v-deep .el-submenu > .el-submenu__title {
      padding: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      .nav-icon-wrap {
        margin-right: 0;
      }
    }
  }
  .logo {
    position: absolute;
    top: 0;
    left: 0;
    background: var(--background-200);
    width: 100%;
    z-index: 100;
    &.isInTelegramWebApp {
      padding-top: calc(var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px));
    }
  }
  .el-menu--inline {
    .grid-box {
      margin-top: 10px;
    }
  }
  .nav-menu-list {
    background: var(--background-1201);
    height: 100%;
    width: 100%;
    transition: width 0.2s linear; /* 设置过渡属性 */
    overflow-y: scroll; /* 隐藏溢出内容 */
    overflow-x: hidden;
    box-sizing: border-box;
    border-right: 1px solid var(--border-color-101);
    &.IsMobile {
      padding-top: 50px;
      &.isInTelegramWebApp {
        padding-top: calc(50px + var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px));
      }
    }
  }
}
::v-deep .el-submenu__icon-arrow {
  width: 24px;
  height: 24px;
  background: var(--background-700);
  border-radius: 6px;
  text-align: center;
  line-height: 24px;
  right: 10px;
  top: 15px;
  &::before {
    font-weight: 600;
    color: var(--font-color-900);
  }
}
::v-deep .el-menu-item {
  min-height: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  overflow: hidden;
  // font-weight: 600;
  &.is-active,
  &:hover {
    background: var(--background-800);
  }
  .unselected {
    display: block;
  }
  .selected {
    display: none;
  }
  .iconSmall {
    display: none;
  }
  .nav-icon-wrap.active {
    .unselected {
      display: none;
    }
    .selected {
      display: block;
    }
  }
  &:hover {
    .name {
      color: var(--font-color-1701);
    }
    .unselected {
      display: none;
    }
    .selected {
      display: block;
    }
  }
}
::v-deep .el-submenu__title {
  min-height: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  overflow: hidden;
  // font-weight: 600;
  .unselected {
    display: block;
  }
  .selected {
    display: none;
  }
  .iconSmall {
    display: none;
  }
  .nav-icon-wrap.active {
    .unselected {
      display: none;
    }
    .selected {
      display: block;
    }
  }
  &:hover {
    background: var(--background-800);
    .name {
      color: var(--font-color-1701);
    }
    .unselected {
      display: none;
    }
    .selected {
      display: block;
    }
  }
}
.redPoint {
  background-color: var(--tips-100);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  left: 28px;
  top: 10px;
  z-index: 9;
}
.redPoint:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  margin-top: -4px;
  margin-left: -4px;
  background-color: var(--tips-100);
  -webkit-animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes ping {
  75% {
    -webkit-transform: scale(2.5);
    -ms-transform: scale(2.5);
    transform: scale(2.5);
    opacity: 0.4;
  }
  100% {
    -webkit-transform: scale(2.5);
    -ms-transform: scale(2.5);
    transform: scale(2.5);
    opacity: 0;
  }
}
.nav-menu-wrap {
  &.isInTelegramWebApp {
    // .h-header-box {
    //   background: var(--background-1200);
    // }
    .logo {
      // top: calc(var(--tg-safe-area-inset-top, 0px));
      padding-top: calc(var(--tg-safe-area-inset-top, 0px));
    }
    .nav-menu-list.IsMobile {
      padding-top: calc(50px + var(--tg-safe-area-inset-top, 0px));
    }
  }
}
</style>
